import { render, staticRenderFns } from "./foreman.vue?vue&type=template&id=6aaab66a&"
import script from "./foreman.vue?vue&type=script&lang=js&"
export * from "./foreman.vue?vue&type=script&lang=js&"
import style0 from "./foreman.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports